import ShopCUG from "cug-shop";
import Vue from "vue";
import store from "../store"

Vue.use(ShopCUG, {
  store
});